const headerData = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	// {
	//   prop: "StatusName",
	//   label: "状态",
	//   columnwidth: 105,
	// },
	{
		prop: "InvoiceCheckedName",
		label: "发票是否校验",
		columnwidth: 140,
	},
	{
		prop: "SBCode",
		label: "发票代码",
		columnwidth: 130,
	},
	{
		prop: "InvoiceNo",
		label: "发票号码",
		columnwidth: 100,
	},
	{
		prop: "SBDate",
		label: "开票日期",
		columnwidth: 162,
	},
	{
		prop: "ReturnName",
		label: "发票状态",
		columnwidth: 100,
	},
	{
		prop: "CusName",
		label: "付款方",
		columnwidth: 233,
	},
	{
		prop: "TerminalHPName",
		label: "终端医院",
		columnwidth: 230,
	},
	// {
	//   prop: "CusName",
	//   label: "客户",
	//   columnwidth: 100,
	// },
	{
		prop: "Remark",
		label: "备注",
		columnwidth: 150,
	},
	{
		prop: "VerifyCode",
		label: "发票校验码",
		columnwidth: 180,
	},
	{
		prop: "CheckWayName",
		label: "发票类型",
		columnwidth: 131,
	},
	{
		prop: "VouCode",
		label: "经销商出库单号",
		columnwidth: 125,
	}, {
		prop: "BlueInvoiceNo",
		label: "重开蓝票号",
		columnwidth: 150,
	},
	// {
	//   prop: "VouCode",
	//   label: "出库单号",
	//   columnwidth: 230,
	// },
	// {
	//   prop: "OuterCode",
	//   label: "外部订单号",
	//   columnwidth: 230,
	// },
	{
		prop: "Total",
		label: "发票金额",
		columnwidth: 92,
	},

	{
		prop: "CheckedRemark",
		label: "发票标注内容",
		columnwidth: 306,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 232,
	},
	{
		prop: "CreateTime",
		label: "上传时间",
		columnwidth: 162,
	},
	{
		prop: "UpdaterName",
		label: "修改人",
		columnwidth: 232,
	},
	{
		prop: "UpdateTime",
		label: "修改时间",
		columnwidth: 101,
	},
	{
		prop: "VerifierName",
		label: "审核人",
		columnwidth: 232,
	},
	{
		prop: "VerifyTime",
		label: "审核时间",
		columnwidth: 162,
	},
];

export default headerData;